import React, { useContext } from 'react';
import { StripedTableCell, StripedTableRow } from '@adserve/adserve-react-components';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

const DeliveryTableTotalRow = ({
    columnDefinitions,
    data,
    index,
    border,
    active = false,
    onHover,
    isHighlighted = false,
    onClick
}) => {
    const { locale, currency } = useContext(SystemSettingsContext);

    const cellStyle = {
        height: 25,
        padding: '0 20px',
        fontFamily: 'roboto',
        fontSize: 14,
        color: '#414141'
    };

    const activeBorder = '1px solid #FD9A00';

    const formatCurrency = (value) => {
        if (isNaN(value)) return value;

        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);
    };

    const formatNumber = (value) => {
        if (isNaN(value)) return value;

        return new Intl.NumberFormat(locale, {
            maximumFractionDigits: 2
        }).format(value);
    };

    const renderValue = (column) => {
        switch (column.type) {
            case 'currency':
                return formatCurrency(data[column.field]);
            case 'number':
                return formatNumber(data[column.field]);
            default:
                return data[column.field];
        }
    };

    return (
        <StripedTableRow
            id={`table-compact-table-row-${index}`}
            isFirstRow={index === 1}
            border={border}
        >
            {columnDefinitions.map((d, i) => {
                return (
                    <StripedTableCell
                        border={border}
                        index={index}
                        key={`cell${i}`}
                        style={{
                            ...cellStyle,
                            borderLeft: i === 0 ? (active ? activeBorder : border) : '',
                            cursor: isHighlighted && i === 0 ? 'pointer' : 'default',
                            textAlign: i === 0 ? 'left' : 'right',
                            color: i === 0 ? '#0A04B4' : '#414141',
                            width: i === 0 ? '300px' : '117px'
                        }}
                        onHover={onHover}
                        isHighlighted={isHighlighted}
                        onClick={onClick}
                    >
                        {renderValue(d)}
                    </StripedTableCell>
                );
            })}
        </StripedTableRow>
    );
};

export default DeliveryTableTotalRow;
